export default __webpack_public_path__ + "static/media/puppeteer.f38ee775.png";